import { Component, HostListener } from '@angular/core';
import { Platform, ModalController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { SettingsProvider } from '../providers/settings/settings';
import { TermsAndConditionsPage, UserConsentResult } from '../pages/terms-and-conditions/terms-and-conditions';
import { NameSurveyProvider } from '../providers/name-survey/name-survey';
import { AnalyticsProvider } from '../providers/analytics/analytics';

const allowAnalyticsSettingsName = "allowAnalytics";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = HomePage;

  constructor(
    platform: Platform,
    statusBar: StatusBar,
    splashScreen: SplashScreen,
    settings: SettingsProvider,
    nameSurvey: NameSurveyProvider,
    modalCtrl: ModalController,
    analytics: AnalyticsProvider
  ) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });

    if (settings.getLocal(allowAnalyticsSettingsName) === null) {
      let modal = modalCtrl.create(TermsAndConditionsPage);
      modal.onDidDismiss((result: UserConsentResult) => {
        settings.setLocalBool(allowAnalyticsSettingsName, result.acceptedAnalytics);
        if (result.acceptedAnalytics) {
          analytics.enableTracking();
        }
      });
      modal.present();
    }

    window.addEventListener('beforeunload', function (e) {
      if (this.location.href.indexOf('localhost') >= 0) {
        return; // disable for development
      }
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = ""; // todo add message here if there is unsaved data?
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/app.component.ts